export enum VerifyPinTypes {
  QRCODE = 'QRCODE',
  SCANCODE = 'SCANCODE',
}
